export const CAMPAIGNS_BASE_PATH = '/campaigns';
export const CAMPAIGNS_DASHBOARD_PATH = 'dashboard';
export const MY_CAMPAIGNS_PATH = 'my-campaigns';
export const CREATE_CAMPAIGN_PATH = 'create';
export const LEADGEN_NURTURING_PATH = 'leadGeneration-Nurturing';
export const CAMPAIGN_ANALYTICS_PATH = 'analytics';
export const CAMPAIGN_TEMPLATE_DETAILS_PATH = 'details';
export const CAMPAIGN_CONSTRUCT = 'construct';
export const CAMPAIGN_CUSTOMIZE = 'customize';
export const CAMPAIGN_SCHEDULE = 'schedule';
export const CAMPAIGN_EDIT = 'edit';
export const CAMPAIGN_EDIT_BY_ID = '/:campaignId/edit';
export const CAMPAIGN_ID = 	':id';
export const CAMPAIGN_TRACKER = 'tracker';
export const CAMPAIGN_TRACKER_BY_ID = '/:campaignId/tracker';
export const CAMPAIGN_EMAIL_ANALYTICS_PATH = 'email-analytics';
export const LEAD_CONVERSION_DETAIL_PATH = 'lead-conversion-detail';
export const EMAIL_BASE_PATH = '/Emails/email';

export const SEARCH_RESULTS_BASE_PATH = '/global-search';

export const PAGE_TITLES = {
	'landing' : 'Bamboo Dashboard',
	'globalSearch': 'Search Results',
	'media': 'Media',
	'previousSearch': 'Previous Search Results'
};

export const noResultsFoundMessage = 'Sorry, no results were found';

export const SCREEN_RESOLUTION_BREAK_POINTS = {
	xs: 480,
	sm: 768,
	md: 992,
	lg: 1200,
	xl: 1600,
	xxl: 1920
};

export const defaultRowCount = 10;

export const MEDIA_WITH_VERSION_FETCH_REQUEST = 'MEDIA_WITH_VERSION_FETCH_REQUEST';
export const MEDIA_WITH_VERSION_FETCH_SUCCESS = 'MEDIA_WITH_VERSION_FETCH_SUCCESS';
export const MEDIA_WITH_VERSION_FETCH_FAILURE = 'MEDIA_WITH_VERSION_FETCH_FAILURE';

export const MEDIA_WITH_VERSION_MORE_FETCH_REQUEST = 'MEDIA_WITH_VERSION_MORE_FETCH_REQUEST';
export const MEDIA_WITH_VERSION_MORE_FETCH_SUCCESS = 'MEDIA_WITH_VERSION_MORE_FETCH_SUCCESS';
export const MEDIA_WITH_VERSION_MORE_FETCH_FAILURE = 'MEDIA_WITH_VERSION_MORE_FETCH_FAILURE';